import type { GroupRole as GroupRoleModel } from '@/adapters/catalogv1.g';

export function extractGroupRole(model: GroupRoleModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    roleRef: model.role_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupRole = ReturnType<typeof extractGroupRole>;
